import React from 'react'
import styles from './styles.module.css'
// import moment from 'moment'
// import { createUseStyles } from 'react-jss'
// import { Button } from './components'

export const ExampleComponent = ({ text }) => {
  return <div className={styles.test}>Example Component0: {text}</div>
}

export * from './core'
